import React from "react";

const ImageSection = () => {
  return (
    <div className="w-full">
      <img
        src="/images/slider1.png"
        alt="Koltuk ve Kuru Temizleme Simgesi"
        className="w-full h-50 max-w-md mx-auto"
      />
    </div>
  );
};

export default ImageSection;
